import { createContext } from 'react'

/**
 * True when the subtree is a real app page mounted inside another surface
 * (e.g. Simple Mode's EmbeddedPagePanel memory router). Embedded pages share
 * the host document, so document-level side effects — document.title via
 * useDocumentTitle — must stay suppressed: the user is still on the host
 * page, not the embedded one.
 */
export const EmbeddedSurfaceContext = createContext(false)
